module.exports = __webpack_public_path__ + "static/ringsavvy-company-brochure-0b3d7449d16de69b1a2713eaad4dcbdb.pdf";